export const LOAD = "ompnt/localStore/LOAD"

export function loadLocalStore() {
  return {
    type: LOAD,
  }
}
